var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportadorXlsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4.54545,
    fill: "#E0F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 4.54545,
    fill: "#EFF5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3176_35997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.8318C15.9392 11.8318 14.6822 13.1075 14.6822 14.6636L14.6682 37.3318C14.6682 38.8925 15.9299 40.1636 17.486 40.1636H34.5C36.0607 40.1636 37.3318 38.8878 37.3318 37.3318V20.9206C37.3318 20.5467 37.1822 20.1822 36.9159 19.9206L29.2477 12.2477C28.9813 11.9813 28.6215 11.8318 28.2477 11.8318H17.5ZM27.4159 21.0421V13.9579L35.2103 21.7523H28.1262C27.7336 21.7523 27.4159 21.4346 27.4159 21.0421Z",
    fill: "#150B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1168 24.1121H23.1682C22.1256 24.1121 21.2804 24.9574 21.2804 26V32.6121C21.2804 33.6548 22.1256 34.5 23.1682 34.5H41.1168C42.1594 34.5 43.0047 33.6548 43.0047 32.6121V26C43.0047 24.9574 42.1594 24.1121 41.1168 24.1121Z",
    fill: "url(#paint0_linear_3176_35997)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3176_35997",
    x1: 45.8645,
    y1: 29.9813,
    x2: 21.9766,
    y2: 28.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1155BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB2EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3176_35997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportadorXlsIcon);
export default __webpack_public_path__ + "static/media/importador-xls-icon.d2879b78c36c82b42bc615ff30437c4b.svg";
export { ForwardRef as ReactComponent };